import fastConfigurationModalContainer from './fastConfigurationModalContainer'
import FastConfigurationModal from './FastConfigurationModal'

export default fastConfigurationModalContainer(FastConfigurationModal)
